export class LocalConstants {
    public static keysCollection = 'Keys';
    public static logsCollection = 'Logs';
    public static ordersCollection = 'Orders';
}
